export default __webpack_public_path__ + "static/media/wallet.dc677c53.svg";